export default __webpack_public_path__ + "static/media/Component 70.46649f80.svg";